<template>
  <div>
    <ui-spinner v-if="loading.view == true"></ui-spinner>
    <div v-else>
      <div class="row form-row">
        <div class="col-lg-3">
          <div class="form-group">
            <label for="" class="form-label">Nombre *</label>
            <input
                v-model="name"
                type="text"
                class="form-control form-control-sm"
            />
          </div>
          <div class="form-group text-right">
            <button
                class="btn btn-sm btn-outline-success"
                :disabled="loading.crud"
                @click="onNew"
            >
              Nuevo
            </button>
            <button
                class="ml-2 btn btn-sm btn-primary"
                :disabled="loading.crud"
                @click="onSave"
            >
              Guardar
            </button>
          </div>
        </div>
        <div class="col-lg-9">
          <div class="table-responsive">
            <table class="table table-bordered table-sm table-hover">
              <thead class="table-secondary">
              <tr class="text-center align-middle">
                <th style="width: 100px"></th>
                <th>Nombre</th>
                <th>UC</th>
                <th>UM</th>
              </tr>
              </thead>
              <tbody>
              <tr
                  v-for="item in containers.estaciones"
                  :key="item.idEstacion"
                  class="align-middle text-center"
              >
                <td>
                  <template v-if="item.origen != 0">
                    <button
                        class="btn btn-xs btn-icon btn-light-warning"
                        @click="onEdit(item)"
                    >
                      <span class="fa fa-fw fa-pencil-alt"></span>
                    </button>
                    <button
                        class="btn btn-xs btn-icon btn-light-danger ml-2"
                        @click="onDelete(item)"
                    >
                      <span class="fa fa-fw fa-trash-alt"></span>
                    </button>
                  </template>
                </td>
                <td>{{ item.nombre }}</td>
                <td>{{ item.usuarioCreador }}</td>
                <td>{{ item.usuarioModif }}</td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  layout: "app",
  data() {
    return {
      name: "",
      loading: {
        view: true,
        crud: false,
      },
      containers: {
        id: null,
        estaciones: [],
      },
    };
  },
  async created() {
    const vm = this;

    let {
      data: { content },
    } = await vm.axios.get("/mantenimiento/estaciones");

    vm.containers.estaciones = content.estaciones;

    vm.loading.view = false;
  },
  methods: {
    onSave() {
      let vm = this;
      let fd = {
        name: String(vm.name).trim(),
        _method: "POST",
      };

      if (!fd.name) {
        return vm.$swal.fire(
            "",
            "Completa los campos obligatorios (*)",
            "warning"
        );
      }

      vm.loading.crud = true;

      let endpoint = "/mantenimiento/estaciones";

      if (vm.containers.id) {
        endpoint = `/mantenimiento/estaciones/${vm.containers.id}`;
        fd._method = "PUT";
      }

      vm.axios
          .post(endpoint, fd)
          .then((response) => {
            if (vm.containers.id) {
              let findRow = vm.containers.estaciones.find(
                  (item) => item.idEstacion == vm.containers.id
              );

              findRow.nombre = fd.name;
              findRow.usuarioModif = vm.$store.state.user.codigo;
            } else {
              vm.containers.estaciones.push({
                nombre: fd.name,
                idEstacion: response.data.content.id,
                usuarioCreador: vm.$store.state.user.codigo,
              });

              vm.containers.id = response.data.content.id;
            }

            vm.$toast.fire(response.data.message, "", "success");
          })
          .catch((error) => {
            vm.$toast.fire(error.response.data.message, "", "error");
          })
          .finally(() => {
            vm.loading.crud = false;
          });
    },
    onEdit(pItem) {
      let vm = this;
      vm.containers.id = pItem.idEstacion;
      vm.name = pItem.nombre;
    },
    async onDelete(pItem) {
      let vm = this;
      let response = await vm.$confirm.fire(
          "",
          "¿Seguro que desea eliminar este item?"
      );

      if (response.value) {
        vm.loading.crud = true;

        vm.axios
            .delete(`/mantenimiento/estaciones/${pItem.idEstacion}`)
            .then((response) => {
              let tempRegistros = [...vm.containers.estaciones];
              vm.containers.estaciones = tempRegistros.filter(
                  (item) => item.idEstacion != pItem.idEstacion
              );
            })
            .catch((error) => {
              vm.$toast.fire(error.response.data.message, "", "error");
            })
            .finally(() => {
              vm.loading.crud = false;
            });
      }
    },
    onNew() {
      let vm = this;
      vm.containers.id = null;
      vm.name = "";
    },
  },
};
</script>
